// Componente Modal - Diálogo modal reutilizable
// Proporciona un modal con overlay, animaciones y diferentes variantes

import { useEffect } from 'react'
import './Modal.css'

/**
 * Componente Modal
 * @param {Object} props - Propiedades del componente
 * @param {boolean} props.isOpen - Si el modal está abierto
 * @param {Function} props.onClose - Función a ejecutar al cerrar
 * @param {string} props.title - Título del modal
 * @param {ReactNode} props.children - Contenido del modal
 * @param {string} props.variant - Variante: 'default', 'danger', 'warning', 'success'
 * @param {string} props.size - Tamaño: 'small', 'medium', 'large'
 * @param {boolean} props.showCloseButton - Mostrar botón de cerrar
 */
function Modal({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  variant = 'default',
  size = 'medium',
  showCloseButton = true
}) {
  // Cerrar con tecla Escape
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      // Prevenir scroll del body cuando el modal está abierto
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = 'unset'
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className={`modal-content modal-${variant} modal-${size}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header del modal */}
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          {showCloseButton && (
            <button 
              className="modal-close-btn"
              onClick={onClose}
              aria-label="Cerrar"
            >
              ✕
            </button>
          )}
        </div>

        {/* Contenido del modal */}
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  )
}

export default Modal

